// extracted by mini-css-extract-plugin
module.exports = {"wrapperCreation":"PublicationSection_wrapperCreation__3qQCq","iconSquare":"PublicationSection_iconSquare__36oqL"};